import { publicUrlFor } from "../../globals/constants";

function BBQImage(props) {
    return(
        <>
            <img {...props} src={publicUrlFor(props.src)} alt={props.alt}/>
        </>
    )
}

export default BBQImage;